// screens/DocumentsScreen/DocumentsScreen.jsx
import React, { useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import CategoryList from "../../components/Documents/CategoryList";
import DocumentList from "../../components/Documents/DocumentList";

const DocumentsScreen = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" fontWeight={700} color="#1A1A2E">
          Documents
        </Typography>
        <Typography variant="body2" color="#6B7280">
          Manage all documents and files
        </Typography>
      </Box>

      <Box sx={{ display: "flex", gap: 3, flexDirection: { xs: "column", md: "row" } }}>
        <Box sx={{ width: { xs: "100%", md: 280 }, flexShrink: 0 }}>
          <CategoryList
            selectedCategory={selectedCategory}
            onSelectCategory={setSelectedCategory}
          />
        </Box>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <DocumentList
            selectedCategory={selectedCategory}
            searchQuery={searchQuery}
            onSearchChange={setSearchQuery}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default DocumentsScreen;